@if (vkforgs$ | async; as vkforgs) {
  <div
    (click)="(vkforgs?.length || 0) > 1 && onChangeAccount(vkforgs)"
    [ngClass]="
      (vkforgs?.length || 0) > 1
        ? 'bg-primary-600 hover:brightness-110 cursor-pointer'
        : ''
    "
    class="w-full flex flex-row items-center justify-between mt-3 py-3 -mb-4 px-4 border-t"
  >
    @if (vkforg$ | async; as selectedVkforg) {
      @if ((vkforgs?.length || 0) > 1) {
        <div class="text-primary-contrast-600">
          {{ selectedVkforg?.kurzbezeichnung || selectedVkforg?.vkforg }}
        </div>
      }
      @if ((vkforgs?.length || 0) <= 1) {
        <span>{{
          selectedVkforg?.kurzbezeichnung ||
            selectedVkforg?.vkforg ||
            vkforgs[0]?.kurzbezeichnung
        }}</span>
      }
    }
    @if ((vkforgs?.length || 0) > 1) {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="text-primary-contrast-600 w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
          clip-rule="evenodd"
        />
      </svg>
    }
  </div>
}

@if (patchContextService.pending$ | async) {
  <soft-blocking-loading-spinner></soft-blocking-loading-spinner>
}
